import { capitalizeEachWord, concat } from '@/helpers/string';

import type { IPerson } from '@/types/person';

export function formatFullName(
	person: string | { firstname?: string; lastname?: string } | undefined | null
) {
	if (!person) return '';
	if (typeof person === 'object') {
		const firstnameFormatted = capitalizeEachWord(person.firstname);
		const lastnameFormatted = person.lastname?.toUpperCase();
		return concat([lastnameFormatted, firstnameFormatted]);
	}
	return capitalizeEachWord(person);
}

export const formatPerson = (person?: IPerson): string => {
	if (!person) return '';
	return concat([person.firstname, person.lastname]);
};
